module.exports = __webpack_public_path__ + "static/media/_MIC2671.thumbnail.bf055625.png";